// commenting out plog so that this util could be used in browser
// import { plog } from "@polyai/stream/plog";

import { createReferenceAdapter } from '../../references';
import { ArtifactEntityType, EntityType } from './types';

export const {
  selectors: entityReferencesSelectors,
  ...entityReferencesAdapter
} = createReferenceAdapter(['flowSteps', 'noCodeSteps']);

export const convertProtoEntityTypeToEntityType = (
  type: string,
): EntityType => {
  switch (type) {
    case 'numeric':
      return EntityType.NUMERIC;
    case 'address':
      return EntityType.ADDRESS;
    case 'freeText':
      return EntityType.FREE_TEXT;
    case 'nameConfig':
      return EntityType.NAME;
    case 'enum':
      return EntityType.ENUM;
    case 'alphanumeric':
      return EntityType.ALPHANUMERIC;
    case 'time':
      return EntityType.TIME;
    case 'phoneNumber':
      return EntityType.PHONE_NUMBER;
    case 'date':
      return EntityType.DATE;
    case 'email':
      return EntityType.EMAIL;
    case 'currency':
      return EntityType.CURRENCY;
    case 'quantity':
      return EntityType.QUANTITY;
    default:
      return EntityType.FREE_TEXT;
  }
};

export const convertProtoEntityTypeToArtifactEntityType = (
  type: string,
): ArtifactEntityType => {
  switch (type) {
    case 'numeric':
      return ArtifactEntityType.NUMERIC;
    case 'address':
      return ArtifactEntityType.ADDRESS;
    case 'freeText':
      return ArtifactEntityType.FREE_TEXT;
    case 'nameConfig':
      return ArtifactEntityType.NAME;
    case 'enum':
      return ArtifactEntityType.ENUM;
    case 'alphanumeric':
      return ArtifactEntityType.ALPHANUMERIC;
    case 'time':
      return ArtifactEntityType.TIME;
    case 'phoneNumber':
      return ArtifactEntityType.PHONE_NUMBER;
    case 'date':
      return ArtifactEntityType.DATE;
    case 'email':
      return ArtifactEntityType.EMAIL;
    case 'currency':
      return ArtifactEntityType.CURRENCY;
    case 'quantity':
      return ArtifactEntityType.QUANTITY;
    default:
      return ArtifactEntityType.FREE_TEXT;
  }
};
